export const FROM_MAP_ROOT = "map-root";
export const FROM_MAP_UNDO_REDO = "map-undo-redo";
export const ZOOM_LEVEL_TO_SHOW_SITEMAPS = 10;
export const GOOGLE_MAPS_SATELLITE_MAP_BACKGROUND_NAME = "Google Satellite";
